export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-emerald-50 to-teal-50 text-gray-800 py-12 mt-16">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="mb-8">
          <div className="flex items-center gap-3 mb-6">
            <span className="font-bold text-teal-700">コインランドリー経営をお考えの方へ</span>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
            <a href="https://www.laundrysite.jp/open.html" className="text-sm text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
              開業したい方
            </a>
            <a href="https://www.laundrysite.jp/sell.html" className="text-sm text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
              中古機を売りたい方
            </a>
            <a href="https://www.laundrysite.jp/buy.html" className="text-sm text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
              中古機を買いたい方
            </a>
            <a href="https://www.laundrysite.jp/property.html" className="text-sm text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
              テナント情報
            </a>
            <a href="https://www.laundrysite.jp/information.html" className="text-sm text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
              お役立ち情報
            </a>
          </div>
        </nav>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 text-xs mb-8">
          <a href="https://www.laundrysite.jp/site-owner.html" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
            サイト運営管理者
          </a>
        </div>

        <div className="text-center mb-6">
          <a href="/" className="inline-block mb-4 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/b20bf12da98b13bf6586d3e638cf3b35.jpeg" 
              alt="Next Stage Logo" 
              className="h-16 w-auto mx-auto"
              loading="lazy"
              decoding="async"
            />
          </a>
          <p className="text-base font-bold text-gray-800 mb-2">会社名：Next stage（ネクストステージ）</p>
          <p className="text-base font-bold text-gray-800 mb-4">所在地：大阪府大阪市中央区東心斎橋1丁目9-19-307</p>
          <p className="text-sm text-gray-700 mb-6">コインランドリー経営のことなら、お気軽にご相談ください。</p>
          
          <div className="w-full max-w-4xl mx-auto mb-6">
            <div className="relative w-full h-80 rounded-lg overflow-hidden shadow-md">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.2!2d135.5!3d34.67!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDQwJzEzLjIiTiAxMzXCsDMwJzAwLjAiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="大阪府大阪市中央区東心斎橋1丁目9-19-307の地図"
                onClick={(e) => {
                  e.preventDefault();
                  window.open('https://www.google.com/maps/search/大阪府大阪市中央区東心斎橋1丁目9-19-307', '_blank', 'noopener,noreferrer');
                }}
                className="cursor-pointer"
              ></iframe>
              <a
                href="https://www.google.com/maps/search/大阪府大阪市中央区東心斎橋1丁目9-19-307"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute inset-0 z-10"
                aria-label="Google Mapで開く"
              ></a>
            </div>
          </div>
        </div>

        <div className="text-xs text-center text-gray-600 border-t border-teal-200 pt-6">
          <p>COPYRIGHT(C) MITSUI FUDOSAN REALTY Co.,Ltd. All Rights Reserved.</p>
          <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="inline-block mt-2 text-teal-600 hover:text-teal-700 transition-colors cursor-pointer">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}